import images from "./images";

const home = [
  {
    id: 1,
    image: images.home1,
    subtitle: "Welcome to Sparkle Laundry",
    title: "Freshen Up, Explore Our Laundry Services",
    buttonText: "Our Services",
    buttonLink: "Services",
  },
  {
    id: 2,
    image: images.home2,
    subtitle: "Introducing Sparkle Laundry",
    title: "Revitalize, Unleash Our Laundry Magic",
    buttonText: "Our Services",
    buttonLink: "Services",
  },
  {
    id: 3,
    image: images.home3,
    subtitle: "Discover Sparkle Laundry Magic",
    title: "Embrace Freshness with Our Solutions",
    buttonText: "Our Services",
    buttonLink: "Services",
  },
];

export default home;